import axios from 'axios';

import { useState } from 'react';
import endpoints from '@constants/configs/endpoints';
import {
    insuranceType
} from './IssuerConstants';
interface TestResults {
    insuranceType?: string | null;
    hiosIssuerId?: string | null;
    testCases?: any[] | null;
}

export default () => {
    const api = axios.create({
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window.csrf_token,
            'X-UID': window.UID,
            'X-EMAIL': window.EMAIL,
            'csrftoken': window.csrf_token
        },
        responseType: 'json'
    });

    const [descriptionData, dispatchD] = useState({});
    const [testResults, dispatchT] = useState<TestResults>({});
    const [apiError, setError] = useState('');

    const getTestResults = async (hhId: string | null, insuranceTypeParam='both') => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.SSIO_TEST_PLAN_RESULTS : '/mocks/issuer-edi/stepResponse.json';
            const res = global.__ENV__.PRODUCTION ? await api.post(url, {'hiosIssuerId':hhId}) : await api.get(url);
            if (res.data) {
                if (insuranceTypeParam === 'both') {
                    dispatchT(res.data);
                } else {
                    dispatchT(res.data[insuranceTypeParam === insuranceType.HEALTH ? 0 : 1]);
                }
                setError('');
            }
        } catch (e) {
            console.error('error', e);
            setError('Fetch Test Results failed. ' + e.message);
        }
    };

    const executeStep = async (stepObj) => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.SSIO_EXECUTE_STEP : '/mocks/issuer-edi/stepResponse.json';
            const res = global.__ENV__.PRODUCTION ? await api.post(url, stepObj) : await api.get(url);
            return Promise.resolve(res.data);
        }
        catch (e) {
            return Promise.resolve(e);
        }
    };

    const getTestDetails = async () => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.SSIO_TEST_PLAN_DETAILS : '/mocks/issuer-edi/ssioDescriptionPage-v2.json';
            const res = await api.get(url);
            if (res) {
                dispatchD(res.data);
            }
        } catch (e) {
            console.error('error', e);
        }
    };

    const restartTestCase = async (restartObj) => {
        try {
            const url = global.__ENV__.PRODUCTION ? endpoints.SSIO_RESTART_STEP : '/mocks/issuer-edi/ssioDescriptionPage-v2.json';
            const res = global.__ENV__.PRODUCTION ? await api.post(url, restartObj) : await api.get(url);
            return Promise.resolve(res.data);
        } catch (e) {
            return Promise.resolve(e);
        }
    };

    return {
        descriptionData,
        testResults,
        apiError,
        getTestDetails: () => {
            getTestDetails();
        },
        executeStep: (stepObj: object) => {
            return executeStep(stepObj);
        },
        getTestResults: (hhId: string | null, insuranceType='both') => {
            getTestResults(hhId, insuranceType);
        },
        restartTestCase: (restartObj) => {
            return restartTestCase(restartObj);
        }
    };
};